import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Close as CloseIcon, Search as SearchIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { AxlButton } from 'components/AxlButton';

const useStyles = makeStyles()((theme) => ({
  searchForm: {
    marginTop: theme.spacing(2),
    marginBottom: 20,
    display: 'flex',
    '&>div': {
      fontSize: 14,
      borderRadius: '3px',
      verticalAlign: 'bottom',
      minWidth: '120px',
      color: theme.palette.secondary.main,
      '&>.MuiSelect-icon': {
        color: theme.palette.secondary.main,
      },
      '&>.MuiOutlinedInput-input': {
        paddingTop: '12px',
        paddingBottom: '12px',
      },
      '&>.MuiIconButton': {
        padding: '8px',
      },
    },
  },
  searchInput: {
    flexGrow: 2,
    marginLeft: 20,
    backgroundColor: '#fff',

    '&>.MuiInputBase-root': {
      fontSize: 14,
      '&>.MuiOutlinedInput-input': {
        paddingTop: '12px',
        paddingBottom: '12px',
      },
    },
  },
  searchIcon: {
    color: '#bebfc0',
  },
  searchBtn: {
    backgroundColor: '#75c31e',
  },
  closeBtn: {
    padding: '8px',
  },
}));
SearchForm.propTypes = {
  onSubmit: PropTypes.func,
  reset: PropTypes.func,
};

function SearchForm(props) {
  const { onSubmit = null, reset = null } = props;
  const [keyword, setKeyword] = useState('');
  const { classes } = useStyles();
  const navigate = useNavigate();
  const addAction = (e) => {
    e.preventDefault();
    navigate('/warehouses/add');
  };

  function handleChangeSearch(e) {
    if (!onSubmit) return;
    setKeyword(e.target.value);

    if (e.target.value === '') {
      return reset(e);
    }
  }

  function handleResetSearch(e) {
    if (!reset) return;

    setKeyword('');
    reset(e);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      onSubmit(e.target.value);
      e.preventDefault();
    }
  }

  return (
    <form className={classes.searchForm} noValidate autoComplete="off">
      <AxlButton variant="contained" color="primary" className={classes.searchBtn} onClick={addAction}>
        + NEW
      </AxlButton>
      <TextField
        onChange={handleChangeSearch}
        onKeyDown={handleKeyDown}
        variant="outlined"
        id="standard-start-adornment"
        value={keyword}
        className={classes.searchInput}
        placeholder="Search for warehouse by warehouse ID, name, address…"
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment className={classes.searchIcon} position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: keyword && (
              <IconButton className={classes.closeBtn} onClick={() => handleResetSearch()} size="large">
                <CloseIcon />
              </IconButton>
            ),
          },
        }}
      />
    </form>
  );
}

export default SearchForm;
